import list from 'src/modules/tipoPresupuesto/list/tipoPresupuestoListReducers';
import form from 'src/modules/tipoPresupuesto/form/tipoPresupuestoFormReducers';
import view from 'src/modules/tipoPresupuesto/view/tipoPresupuestoViewReducers';
import destroy from 'src/modules/tipoPresupuesto/destroy/tipoPresupuestoDestroyReducers';
import importerReducer from 'src/modules/tipoPresupuesto/importer/tipoPresupuestoImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
